import Range from "./Range";
import { Skill } from "./Skill";
export function Resume() {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "1rem",
        }}
      >
        <div
          style={{
            width: "33px",
            heigth: "30px",
            backgroundColor: "hsl(0, 0%, 7%)",
            borderRadius: "20px",
          }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 10 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="rgb(228, 174, 72)"
              d="m368 350.643l-112 63l-112-63v-66.562l-32-17.778v103.054l144 81l144-81V266.303l-32 17.778z"
            />
            <path
              fill="rgb(228, 174, 72)"
              d="M256 45.977L32 162.125v27.734L256 314.3l192-106.663V296h32V162.125Zm160 142.831l-32 17.777L256 277.7l-128-71.115l-32-17.777l-22.179-12.322L256 82.023l182.179 94.463Z"
            />
          </svg>
        </div>
        <h2 style={{ color: "white" }}>Education</h2>
      </div>
      <div className="vertical">
        <div className="list">
          <ul>
            <li>
              <div className="li">
                <h2>Thapar Institute of Engineering and Technology</h2>
                <span>2022-2026</span>
                <span style={{ color: "rgb(157, 152, 152)" }}>
                  Bachelors of Engineering
                </span>
              </div>
            </li>
            <li>
              <div className="li">
                <h2>Sacred Heart School</h2>
                <span>2006-2022</span>
                <span style={{ color: "rgb(157, 152, 152)" }}>
                  10 ICSE , 94.2%
                </span>
                <span style={{ color: "rgb(157, 152, 152)" }}>
                  12 ISC , 94%
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <br />

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "1rem",
        }}
      >
        <div
          style={{
            width: "33px",
            heigth: "30px",
            backgroundColor: "hsl(0, 0%, 7%)",
            borderRadius: "20px",
          }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 10 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="rgb(228, 174, 72)"
              d="m368 350.643l-112 63l-112-63v-66.562l-32-17.778v103.054l144 81l144-81V266.303l-32 17.778z"
            />
            <path
              fill="rgb(228, 174, 72)"
              d="M256 45.977L32 162.125v27.734L256 314.3l192-106.663V296h32V162.125Zm160 142.831l-32 17.777L256 277.7l-128-71.115l-32-17.777l-22.179-12.322L256 82.023l182.179 94.463Z"
            />
          </svg>
        </div>
        <h2 style={{ color: "white" }}>Experience</h2>
      </div>
      <div className="vertical">
        <div className="list">
          <ul>
            <li>
              <div className="li">
                <h2>Atom Space</h2>
                <span>April 2024-current</span>
                <span style={{ color: "rgb(157, 152, 152)" }}>
                  Frontend Developer
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <Range />
    </div>
  );
}
